var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{attrs:{"tile":""}},[(_vm.Check.checkType == 'in')?_c('SectionCheckIn',{ref:"sectionCheckIn",attrs:{"Check":_vm.Check,"Section":_vm.Section,"runLimit":_vm.runLimit}}):_vm._e(),(_vm.Check.checkType == 'out')?_c('SectionCheckOut',{ref:"sectionCheckOut",attrs:{"Check":_vm.Check,"Section":_vm.Section}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }